import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";

const AuthCallback = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const [isWaiting, setIsWaiting] = useState(true);

  // Log when component mounts/unmounts
  useEffect(() => {
    const timestamp = new Date().toISOString();
    console.log(`[${timestamp}] AuthCallback MOUNTED`);
    
    return () => {
      console.log(`[${new Date().toISOString()}] AuthCallback UNMOUNTING`);
    };
  }, []);

 useEffect(() => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] AuthCallback - accounts changed:`, accounts.length);
  
  if (accounts.length > 0) {
    console.log(`[${timestamp}] User authenticated with account:`, accounts[0].username);
    console.log(`[${timestamp}] NOT NAVIGATING - staying on AuthCallback for debugging`);
    
    // DON'T NAVIGATE FOR NOW - let's see if this stops the redirect
    /*
    const timeoutId = setTimeout(() => {
      navigate('/');
    }, 5000);
    return () => clearTimeout(timeoutId);
    */
  } else {
    console.log(`[${timestamp}] No accounts found, waiting...`);
    // Still wait and check
    const timeoutId = setTimeout(() => {
      if (accounts.length === 0) {
        console.log(`[${new Date().toISOString()}] Still no accounts, redirecting to login`);
        navigate('/Login');
      }
    }, 8000);
    return () => clearTimeout(timeoutId);
  }
}, [accounts, navigate, instance, location]);

  // Log when location changes
  useEffect(() => {
    console.log(`[${new Date().toISOString()}] AuthCallback location changed:`, location.pathname);
  }, [location]);

  return (
    <div style={{ padding: '20px' }}>
      <h2>Processing Authentication...</h2>
      <p>Accounts found: {accounts.length}</p>
      <p>Current URL: {window.location.href}</p>
      <p>Location pathname: {location.pathname}</p>
      <p>Component mounted at: {new Date().toISOString()}</p>
      {accounts.length > 0 && (
        <div>
          <p>Authenticated as: {accounts[0].username}</p>
          <p>Will redirect to home in 5 seconds...</p>
        </div>
      )}
      {accounts.length === 0 && (
        <p>Waiting for accounts to be populated...</p>
      )}
    </div>
  );
};

export default AuthCallback;